import { render, staticRenderFns } from "./fluxos.vue?vue&type=template&id=04bc5cf0&scoped=true"
import script from "./fluxos.vue?vue&type=script&lang=js"
export * from "./fluxos.vue?vue&type=script&lang=js"
import style0 from "./fluxos.vue?vue&type=style&index=0&id=04bc5cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bc5cf0",
  null
  
)

export default component.exports